// extracted by mini-css-extract-plugin
export default {"chat":"_1YU9","chatContainer":"_2BOl","separator":"_2d8u"};